var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left m-2"},[_c('a',{staticClass:"back-btn",on:{"click":_vm.goBack}},[_c('i',{staticClass:"far fa-arrow-alt-circle-left"}),_vm._v(" Back ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }